export default {
  state: {
    projectData: {},
    group: null
  },
  mutations: {
    SET_PROJECTDATA(state, data) {
      state.projectData = data;
    },
    SET_GROUP(state, data) {
      state.group = data;
    }
  },
  actions: {},
  getters: {
    getProjectData: state => {
      return state.projectData;
    },
    // 是否是叶子 Group
    isLeafGroup: state => {
      return state.group && state.group.is_leaf;
    }
  }
};
